module.exports = __webpack_public_path__ + "img/fallback_060_p.81f16b92.jpg";